import api from './api';

export const groupBookingsService = {
  // Get all group bookings
  getAll: async () => {
    const response = await api.get('/group-bookings');
    return response.data.data || [];
  },

  // Get single group booking
  getById: async (id) => {
    const response = await api.get(`/group-bookings/${id}`);
    return response.data.data || null;
  },

  // Create group booking
  create: async (groupData) => {
    const response = await api.post('/group-bookings', groupData);
    return response.data.data || null;
  },

  // Update group booking
  update: async (id, groupData) => {
    const response = await api.put(`/group-bookings/${id}`, groupData);
    return response.data.data || null;
  },

  // Add participant
  addParticipant: async (groupId, participantData) => {
    const response = await api.post(`/group-bookings/${groupId}/participants`, participantData);
    return response.data.data || null;
  },

  // Get public booking page data
  getPublicBooking: async (publicUrl) => {
    const response = await api.get(`/group-bookings/public/${publicUrl}`);
    return response.data.data || null;
  },

  // Delete participant payment information
  deleteParticipantPayment: async (participantId) => {
    const response = await api.delete(`/group-bookings/participants/${participantId}/payment`);
    return response.data;
  }
};
